import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip } from 'recharts';

const MetricCard = ({ 
  icon, 
  title, 
  value, 
  description, 
  chartData, 
  chartKey, 
  chartColor = "#3b82f6",
  loading = false,
  formatter = null
}) => {
  return (
    <div className="analytics-metric-with-graph">
      <div className="analytics-metric-header">
        {icon}
        <div className="analytics-metric-title">{title}</div>
      </div>
      <div className="analytics-metric-value">
        {loading ? '...' : (formatter ? formatter(value) : value)}
      </div>
      <div className="analytics-metric-desc">{description}</div>
      <div className="analytics-mini-chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <XAxis 
              dataKey="day" 
              tick={{ fontSize: 11, fill: '#666' }} 
              axisLine={{ stroke: '#e0e0e0', strokeWidth: 1 }} 
              tickLine={{ stroke: '#e0e0e0', strokeWidth: 1 }}
            />
            <YAxis 
              tick={{ fontSize: 11, fill: '#666' }} 
              axisLine={{ stroke: '#e0e0e0', strokeWidth: 1 }} 
              tickLine={{ stroke: '#e0e0e0', strokeWidth: 1 }}
              allowDecimals={false}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.95)', 
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                fontSize: '12px'
              }}
              formatter={(value, name) => {
                if (formatter && name === chartKey) {
                  return [formatter(value), title];
                }
                return [value, name];
              }}
              labelFormatter={(label) => `${label}: ${title}`}
            />
            <Line 
              type="monotone" 
              dataKey={chartKey} 
              stroke={chartColor} 
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 5, fill: chartColor }}
            />
            <defs>
              <linearGradient id={`gradient-${chartKey}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={chartColor} stopOpacity={0.3}/>
                <stop offset="95%" stopColor={chartColor} stopOpacity={0}/>
              </linearGradient>
            </defs>
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default MetricCard;
